import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import EventNoteIcon from "@mui/icons-material/EventNote"; // Leave
import HowToRegIcon from "@mui/icons-material/HowToReg"; // Attendance
import SupportAgentIcon from "@mui/icons-material/SupportAgent"; // Support
import "../Styles/Footer.css";
import GroupIcon from "@mui/icons-material/Group";
import PersonIcon from "@mui/icons-material/Person";
import ViewListIcon from "@mui/icons-material/ViewList";
import ShowChartIcon from '@mui/icons-material/ShowChart';

function Footer() {
  const [role, setRole] = useState(null);
  useEffect(() => {
    const storedRole = localStorage.getItem("userRole");
    setRole(storedRole);
  }, []);

  const renderSidebarContent = () => {
    if (role === "super admin") {
      return (
        <>
          <li>
            <Link to="/superadmin">
              <HomeIcon />
              <span>Home</span>
            </Link>
          </li>
          <li>
            <Link to="/create-admin">
              <PersonIcon />
              <span>Admin</span>
            </Link>
          </li>
          <li>
            <Link to="/plans">
              <ViewListIcon />
              <span>Plans</span>
            </Link>
          </li>
          <li>
            <Link to="/reports">
              <ShowChartIcon />
              <span>Reports</span>
            </Link>
          </li>
        </>
      );
    }
    if (role === "admin") {
      return (
        <>
          <li>
            <Link to="/admin">
              <HomeIcon />
              <span>Home</span>
            </Link>
          </li>
          <li>
            <Link to="/manage-users-admin">
              <GroupIcon />
              <span>Users</span>
            </Link>
          </li>
          <li>
            <Link to="/faculty-attendance">
              <HowToRegIcon />
              <span>Attendance</span>
            </Link>
          </li>
          <li>
            <Link to="/leave-request">
              <EventNoteIcon />
              <span>Leaves</span>
            </Link>
          </li>
        </>
      );
    }
    if (role === "faculty") {
      return (
        <>
          <li>
            <Link to="/faculty">
              <HomeIcon />
              <span>Home</span>
            </Link>
          </li>
          <li>
            <Link to="/class-attendance">
              <HowToRegIcon />
              <span>Attendance</span>
            </Link>
          </li>
          <li>
            <Link to="/faculty-leaves-history">
              <EventNoteIcon />
              <span>Leaves</span>
            </Link>
          </li>
          <li>
            <Link to="/customer-support">
              <SupportAgentIcon />
              <span>Support</span>
            </Link>
          </li>
        </>
      );
    }
    if (role === "student") {
      return (
        <>
          <li>
            <Link to="/student">
              <HomeIcon />
              <span>Home</span>
            </Link>
          </li>
          <li>
            <Link to="/view-student-attendance">
              <HowToRegIcon />
              <span>Attendance</span>
            </Link>
          </li>
          <li>
            <Link to="/student-leaves-history">
              <EventNoteIcon />
              <span>Leaves</span>
            </Link>
          </li>

          <li>
            <Link to="/student-customer-support">
              <SupportAgentIcon />
              <span>Support</span>
            </Link>
          </li>
        </>
      );
    }

    return null;
  };

  return (
    <div className="footer">
      <ul className="footer-menu">{renderSidebarContent()}</ul>
    </div>
  );
}

export default Footer;
